
export const getPrefixedQueryString = (queryString: string | undefined): string | undefined => {
  if( !queryString || queryString.startsWith('?') ){
    return queryString
  }
  return '?' + queryString
}
